/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Nodata1Inputs */

const zh_analytics_nodata1 = /** @type {(inputs: Analytics_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`暂无数据`)
};

const en_analytics_nodata1 = /** @type {(inputs: Analytics_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No data available`)
};

const es_analytics_nodata1 = /** @type {(inputs: Analytics_Nodata1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sin datos disponibles`)
};

/**
* | output |
* | --- |
* | "No data available" |
*
* @param {Analytics_Nodata1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_nodata1 = /** @type {((inputs?: Analytics_Nodata1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Nodata1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_nodata1(inputs)
	if (locale === "en") return en_analytics_nodata1(inputs)
	return es_analytics_nodata1(inputs)
});
export { analytics_nodata1 as "analytics_noData" }